// extracted by mini-css-extract-plugin
export default {"items":"courseItem_items__g4snw","item":"courseItem_item__025y2","courseRating":"courseItem_courseRating__hZBB-"};